var chunkMapping = {
	"214": [
		79214
	],
	"986": [
		82986
	]
};
var idToExternalAndNameMapping = {
	"79214": [
		"default",
		"./basename-provider",
		25285
	],
	"82986": [
		"default",
		"./last-week-alerts-table",
		25285
	]
};
var idToRemoteMap = {
	"79214": [
		{
			"externalType": "script",
			"name": "anomaly_detection"
		}
	],
	"82986": [
		{
			"externalType": "script",
			"name": "anomaly_detection"
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes.chunkMapping = chunkMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToExternalAndNameMapping = idToExternalAndNameMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToRemoteMap = idToRemoteMap;
__webpack_require__.remotesLoadingData.moduleIdToRemoteDataMapping = {
	"79214": {
		"shareScope": "default",
		"name": "./basename-provider",
		"externalModuleId": 25285,
		"remoteName": "anomaly_detection"
	},
	"82986": {
		"shareScope": "default",
		"name": "./last-week-alerts-table",
		"externalModuleId": 25285,
		"remoteName": "anomaly_detection"
	}
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}